<div class="flex-container flex-dir-column align-spaced full-height-column">
  <div (click)="handleCart()" class="close" *ngIf="!eanOpen">
    <svg
      height="29.366"
      viewBox="0 0 29.366 29.366"
      width="29.366"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        data-name="Gruppe 39"
        id="Gruppe_39"
        transform="translate(0.798 0.798)"
      >
        <g
          data-name="Gruppe 35"
          id="Gruppe_35"
          transform="translate(0.202 0.202)"
        >
          <circle
            cx="13.683"
            cy="13.683"
            data-name="Ellipse 2"
            fill="none"
            id="Ellipse_2"
            r="13.683"
            stroke="#023e84"
            stroke-miterlimit="10"
            stroke-width="2"
          />
          <line
            data-name="Linie 9"
            fill="none"
            id="Linie_9"
            stroke="#023e84"
            stroke-miterlimit="10"
            stroke-width="2"
            transform="translate(7.985 7.985)"
            x2="11.397"
            y2="11.397"
          />
          <line
            data-name="Linie 10"
            fill="none"
            id="Linie_10"
            stroke="#023e84"
            stroke-miterlimit="10"
            stroke-width="2"
            transform="translate(7.985 7.985)"
            x1="11.397"
            y2="11.397"
          />
        </g>
      </g>
    </svg>
  </div>
  <!-- products-grid und ean jeweils einzeln rendern da die mit anzahl der cart items skalieren und bei JEDER navigation rerendert werden da im app layout -->
  <!-- wir können aber nicht direkt den cart component nicht rendern weil wir eine animation zum schließen + öffnen haben -->
  <!-- es gibt hier einen tradeof zwischen der Zeit die man braucht um das cart zu öffnen vs die Zeit die sonst für die navigation benötigt wird -->
  <app-products-grid
    *ngIf="cartItems && this.cartOpen"
    [cartItems]="cart | async"
    [highlightSkus]="missingSkus"
    [transferedSkus]="transferedSkus"
    [ngClass]="{ hide: eanOpen }"
  >
    <h1>{{ "cart.digital-bag" | i18next }}</h1>
    <div *ngIf="cartItems.length === 0">{{ "cart.empty-cart" | i18next }}</div>
  </app-products-grid>
  <app-show-ean
    [cartItems]="cart | async"
    [ngClass]="{ 'hide-ean': !eanOpen }"
    *ngIf="eanOpen"
  >
    <div (click)="handleEan()" class="btn close-ean">
      {{ "cart.ean-close" | i18next }}
    </div>
  </app-show-ean>
  <div *ngIf="cartItems" class="sticky bottom cart-menu">
    <div [ngClass]="{ hide: eanOpen }" class="boxed">
      <div class="grid align-center">
        <div
          (click)="handleEan()"
          class="xs-2 m-2 flex-container align-center-middle pointer"
        >
          <svg
            class="shrink margin-r-2"
            data-name="Gruppe 158"
            height="40.16"
            width="27.745"
            id="Gruppe_158"
            viewBox="2 -5 30.136 40.16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              data-name="Rechteck 54"
              fill="#161615"
              height="22.619"
              id="Rechteck_54"
              transform="translate(0 0)"
              width="1.499"
            />
            <rect
              data-name="Rechteck 55"
              fill="#161615"
              height="27.735"
              id="Rechteck_55"
              transform="translate(2.468 0)"
              width="0.968"
            />
            <rect
              data-name="Rechteck 56"
              fill="#161615"
              height="27.735"
              id="Rechteck_56"
              transform="translate(4.677 0)"
              width="0.956"
            />
            <rect
              data-name="Rechteck 57"
              fill="#161615"
              height="22.619"
              id="Rechteck_57"
              transform="translate(6.609 0)"
              width="1.498"
            />
            <rect
              data-name="Rechteck 58"
              fill="#161615"
              height="22.619"
              id="Rechteck_58"
              transform="translate(9.308 0)"
              width="0.506"
            />
            <rect
              data-name="Rechteck 59"
              fill="#161615"
              height="22.619"
              id="Rechteck_59"
              transform="translate(11.014 0)"
              width="1.499"
            />
            <rect
              data-name="Rechteck 60"
              fill="#161615"
              height="22.619"
              id="Rechteck_60"
              transform="translate(13.656 0)"
              width="0.621"
            />
            <rect
              data-name="Rechteck 61"
              fill="#161615"
              height="22.619"
              id="Rechteck_61"
              transform="translate(15.42 0)"
              width="1.499"
            />
            <rect
              data-name="Rechteck 62"
              fill="#161615"
              height="22.619"
              id="Rechteck_62"
              transform="translate(18.098 0)"
              width="0.55"
            />
            <rect
              data-name="Rechteck 63"
              fill="#161615"
              height="22.619"
              id="Rechteck_63"
              transform="translate(20.225 0)"
              width="0.7"
            />
            <rect
              data-name="Rechteck 64"
              fill="#161615"
              height="22.619"
              id="Rechteck_64"
              transform="translate(22.028 0)"
              width="1.499"
            />
            <rect
              data-name="Rechteck 65"
              fill="#161615"
              height="27.735"
              id="Rechteck_65"
              transform="translate(24.734 0)"
              width="0.493"
            />
            <rect
              data-name="Rechteck 66"
              fill="#161615"
              height="27.735"
              id="Rechteck_66"
              transform="translate(26.434 0)"
              width="1.499"
            />
            <rect
              data-name="Rechteck 67"
              fill="#161615"
              height="22.619"
              id="Rechteck_67"
              transform="translate(28.637 0)"
              width="1.499"
            />
          </svg>
          <span class="show-for-m">{{ "cart.show-ean" | i18next }}</span>
        </div>
        <div
          (click)="openModal('empty-cart-modal')"
          class="xs-2 m-2 flex-container align-center-middle pointer"
        >
          <svg
            class="scale11 shrink margin-r-2"
            height="31.225"
            viewBox="0 0 27.934 31.225"
            width="27.934"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              data-name="Gruppe 355"
              id="Gruppe_355"
              transform="translate(0.324 0.317)"
            >
              <g data-name="Gruppe 356" id="Gruppe_356">
                <path
                  d="M22.4,40.053H5.525A5.024,5.024,0,0,1,.554,34.3L3.146,16.684A1.731,1.731,0,0,1,4.859,15.2h18.2a1.731,1.731,0,0,1,1.713,1.479L27.365,34.3A5.023,5.023,0,0,1,22.4,40.053Z"
                  data-name="Pfad 167"
                  fill="none"
                  id="Pfad_167"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(-0.317 -9.646)"
                />
                <path
                  d="M18.364,5.976a5.476,5.476,0,1,1,10.952,0"
                  data-name="Pfad 168"
                  fill="none"
                  id="Pfad_168"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(-11.65 -0.317)"
                />
                <path
                  d="M23.157,10.226V5.976a5.476,5.476,0,1,1,10.952,0v4.251"
                  data-name="Pfad 169"
                  fill="none"
                  id="Pfad_169"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(-14.69 -0.317)"
                />
                <circle
                  cx="0.461"
                  cy="0.461"
                  data-name="Ellipse 53"
                  fill="none"
                  id="Ellipse_53"
                  r="0.461"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(8.005 9.448)"
                />
                <circle
                  cx="0.461"
                  cy="0.461"
                  data-name="Ellipse 54"
                  fill="none"
                  id="Ellipse_54"
                  r="0.461"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(18.957 9.448)"
                />
                <path
                  d="M29.605,51.21H18.012l-2.654-3.037,2.654-3.037H29.605Z"
                  data-name="Pfad 170"
                  fill="none"
                  id="Pfad_170"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(-9.743 -28.633)"
                />
                <line
                  data-name="Linie 54"
                  fill="none"
                  id="Linie_54"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(13.492 17.484)"
                  x2="4.111"
                  y2="4.111"
                />
                <line
                  data-name="Linie 55"
                  fill="none"
                  id="Linie_55"
                  stroke="#161615"
                  stroke-miterlimit="10"
                  stroke-width="1"
                  transform="translate(13.492 17.484)"
                  x1="4.111"
                  y2="4.111"
                />
              </g>
            </g>
          </svg>
          <span class="show-for-m">{{ "cart.empty-bag" | i18next }}</span>
          <modal id="empty-cart-modal">
            <div
              (click)="closeModal('empty-cart-modal')"
              class="close-button text-right"
            >
              <svg
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="cancel_24px">
                  <path
                    clip-rule="evenodd"
                    d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                    fill-opacity="1"
                    fill-rule="evenodd"
                    id="icon/navigation/cancel_24px"
                  />
                </g>
              </svg>
            </div>
            <div class="text-center">
              <h1>{{ "cart.empty-bag" | i18next }}</h1>
              <div class="flex-container">
                <button
                  (click)="closeModal('empty-cart-modal')"
                  class="btn secondary"
                >
                  {{ "cart.cancel" | i18next }}
                </button>
                <button (click)="emptyCart()" class="btn primary">
                  {{ "cart.empty" | i18next }}
                </button>
              </div>
            </div>
          </modal>
        </div>
        <div class="xs-2 m-2 flex-container align-center-middle pointer">
          <div
            *ngIf="nativeOfflineReady"
            class="flex-container align-center-middle"
            (click)="handleGeneratePdfClick()"
          >
            <svg
              class="shrink margin-r-2"
              id="Ebene_2"
              height="39.15"
              width="40.27"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40.27 39.15"
            >
              <defs>
                <style>
                  .cls-1 {
                    fill: #fff;
                  }

                  .cls-2 {
                    fill: none;
                    stroke: #fff;
                    stroke-linecap: round;
                    stroke-miterlimit: 10;
                  }
                </style>
              </defs>
              <g id="Ebene_1-2" data-name="Ebene_1">
                <g>
                  <path
                    d="M31.41,28.13l-2.93-19.95c-.18-1.2-1.22-2.09-2.43-2.1h-3.3C22.43,2.68,19.57,0,16.08,0c-.34,0-.67.03-.99.08-.32-.05-.65-.08-.99-.08-3.49,0-6.36,2.67-6.67,6.08h-2c-1.22,0-2.25.9-2.43,2.11L.07,28.14c-.04.3-.07.6-.07.9,0,3.42,2.77,6.18,6.19,6.19h19.1c.3,0,.61-.02.91-.07,3.38-.51,5.71-3.65,5.22-7.03ZM21.74,6.08h-.98c-.17-1.9-1.14-3.56-2.56-4.67,1.91.77,3.31,2.54,3.54,4.67ZM15.09,1.09c2.48.44,4.4,2.46,4.67,4.99h-9.35c.27-2.53,2.2-4.56,4.67-4.99ZM11.98,1.41c-1.43,1.11-2.39,2.77-2.57,4.67h-.98c.23-2.13,1.63-3.9,3.55-4.67ZM26.05,34.17c-.25.04-.51.06-.76.06H6.19c-2.86,0-5.18-2.33-5.19-5.19,0-.25.02-.5.06-.75L3.99,8.34c.11-.71.72-1.25,1.44-1.25h3.94v3.56c-.31.18-.52.49-.52.87,0,.56.46,1.02,1.02,1.02.56,0,1.02-.46,1.02-1.02h0c0-.38-.22-.7-.52-.87v-3.56h11.4v3.56c-.31.18-.52.5-.52.88,0,.56.46,1.02,1.02,1.02.56,0,1.02-.46,1.02-1.02h0c0-.38-.22-.7-.52-.87v-3.56h3.27c.72,0,1.34.53,1.44,1.25l2.93,19.95c.41,2.83-1.54,5.47-4.37,5.89Z"
                  />
                  <polygon
                    points="9.88 12.54 9.88 12.54 9.88 12.54 9.88 12.54"
                  />
                  <polygon
                    points="22.28 12.54 22.28 12.54 22.28 12.54 22.28 12.54"
                  />
                </g>
                <circle cx="32.84" cy="31.72" r="7.43" />
                <path
                  d="M6.24,30.7c.29,0,.35-.03.35-.3v-7.18c0-.42-.01-.43-.75-.52v-.23l.34-.08c.36-.09.86-.21,1.22-.34l.13.05v.84c.49-.57,1.17-.88,1.82-.88,1.59,0,2.17,1.4,2.17,2.83,0,1.87-1.01,3.39-2.64,3.39-.47,0-.94-.16-1.35-.57v2.68c0,.27.05.3.34.3h.52v.33h-2.55v-.33h.4ZM7.53,23.34v2.82c0,1.12.42,1.78,1.33,1.78,1.08,0,1.65-.94,1.65-2.73,0-1.38-.43-2.56-1.64-2.56-.4,0-.88.19-1.34.69Z"
                />
                <path
                  d="M17.51,27.14c0,.23.08.39.31.43l.45.08v.22c-.68.13-.99.2-1.48.36,0,0-.22-.16-.22-.87,0,0-.74.94-1.91.94-1.37,0-2.08-1.18-2.08-2.83,0-1.94,1.14-3.39,2.69-3.39.87,0,1.3.46,1.3.46v-3.24c0-.33-.01-.36-.51-.44l-.23-.04v-.23c.49-.12,1.12-.29,1.56-.42l.12.05v8.93ZM16.58,24.15c0-1.39-.55-1.76-1.3-1.76-1.07,0-1.68.94-1.68,2.72,0,1.4.48,2.6,1.62,2.6.83,0,1.35-.77,1.35-.77v-2.79Z"
                />
                <path
                  d="M19.7,22.77h-.83v-.22l.83-.33c.09-1.52.42-2.72.98-3.29.38-.38.98-.78,1.59-.78.43,0,.75.19.75.64,0,.27-.16.48-.39.48-.42,0-.56-.56-1-.56-.87,0-.99,1.27-.99,2.57v.96h1.3v.52h-1.3v4.68c0,.33.05.34.35.34h.58v.33h-2.7v-.33h.46c.36,0,.38-.04.38-.36v-4.65Z"
                />
                <path
                  class="cls-1"
                  d="M35.48,30.52c-.2-.2-.51-.2-.71,0l-1.43,1.43v-4.54c0-.28-.22-.5-.5-.5s-.5.22-.5.5v4.54l-1.43-1.43c-.2-.2-.51-.2-.71,0s-.2.51,0,.71l2.64,2.64,2.64-2.64c.2-.2.2-.51,0-.71Z"
                />
                <line
                  class="cls-2"
                  x1="29.94"
                  y1="35.41"
                  x2="35.74"
                  y2="35.41"
                />
              </g>
            </svg>
            <span class="show-for-m">{{ "cart.bag-pdf" | i18next }}</span>
          </div>
        </div>
        <div class="xs-2 m-2 flex-container align-center-middle pointer">
          <div
            class="flex-container align-center-middle"
            (click)="openModal('generate-csv')"
          >
            <svg
              class="shrink margin-r-2"
              id="Ebene_2"
              height="39.15"
              width="40.27"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40.27 39.15"
            >
              <defs>
                <style>
                  .cls-1 {
                    fill: #fff;
                  }
                </style>
              </defs>
              <g id="Ebene_1-2" data-name="Ebene_1">
                <g>
                  <path
                    d="M31.42,28.13l-2.93-19.95c-.18-1.2-1.22-2.09-2.43-2.1h-3.3C22.43,2.68,19.57,0,16.08,0c-.34,0-.67.03-.99.08-.32-.05-.65-.08-.99-.08-3.49,0-6.36,2.67-6.67,6.08h-2c-1.22,0-2.25.9-2.43,2.11L.07,28.14c-.04.3-.07.6-.07.9,0,3.42,2.77,6.18,6.19,6.19h19.1c.3,0,.61-.02.91-.07,3.38-.51,5.71-3.65,5.22-7.03ZM21.74,6.08h-.98c-.17-1.9-1.14-3.56-2.56-4.67,1.91.77,3.31,2.54,3.54,4.67ZM15.09,1.09c2.48.44,4.4,2.46,4.67,4.99h-9.35c.27-2.53,2.2-4.56,4.67-4.99ZM11.98,1.41c-1.43,1.11-2.39,2.77-2.57,4.67h-.98c.23-2.13,1.63-3.9,3.55-4.67ZM26.05,34.17c-.25.04-.51.06-.76.06H6.19c-2.86,0-5.18-2.33-5.19-5.19,0-.25.02-.5.06-.75L3.99,8.34c.11-.71.72-1.25,1.44-1.25h3.94v3.56c-.31.18-.52.49-.52.87,0,.56.46,1.02,1.02,1.02.56,0,1.02-.46,1.02-1.02h0c0-.38-.22-.7-.52-.87v-3.56h11.4v3.56c-.31.18-.52.5-.52.88,0,.56.46,1.02,1.02,1.02.56,0,1.02-.46,1.02-1.02h0c0-.38-.22-.7-.52-.87v-3.56h3.27c.72,0,1.34.53,1.44,1.25l2.93,19.95c.41,2.83-1.54,5.47-4.37,5.89Z"
                  />
                  <polygon
                    points="9.88 12.54 9.88 12.54 9.88 12.54 9.88 12.54"
                  />
                  <polygon
                    points="22.28 12.54 22.28 12.54 22.28 12.54 22.28 12.54"
                  />
                </g>
                <circle cx="32.84" cy="31.72" r="7.43" />
                <path
                  class="cls-1"
                  d="M35.48,30.52c-.2-.2-.51-.2-.71,0l-1.43,1.43v-4.54c0-.28-.22-.5-.5-.5s-.5.22-.5.5v4.54l-1.43-1.43c-.2-.2-.51-.2-.71,0s-.2.51,0,.71l2.64,2.64,2.64-2.64c.2-.2.2-.51,0-.71Z"
                />
                <path
                  class="cls-1"
                  d="M35.74,35.91h-5.8c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h5.8c.28,0,.5.22.5.5s-.22.5-.5.5Z"
                />
                <path
                  d="M6.26,22.58c-.18,0-.27,0-.27.08,0,.06.07.14.18.33l.94,1.53,1.14-1.57c.08-.12.14-.2.14-.26s-.06-.1-.19-.1h-.58v-.33h2.11v.33h-.39c-.35,0-.51.08-.74.39l-1.31,1.82,1.6,2.64c.21.35.26.36.68.36h.21v.33h-2.47v-.33h.34c.21,0,.29-.03.29-.1,0-.07-.06-.16-.16-.3l-1.11-1.79-1.29,1.78c-.06.09-.13.18-.13.26,0,.09.04.16.21.16h.56v.33h-2.18v-.33h.44c.29,0,.49-.09.72-.4l1.51-2.05-1.44-2.35c-.25-.39-.31-.4-.73-.4h-.16v-.33h2.46v.33h-.35Z"
                />
                <path
                  d="M10.24,28.11v-.33h.35c.43,0,.43-.01.43-.42v-8.02c0-.42,0-.43-.51-.51l-.25-.04v-.23l.27-.07c.36-.09.86-.21,1.27-.35l.14.04v9.18c0,.4,0,.42.42.42h.35v.33h-2.48Z"
                />
                <path
                  d="M16.91,22.25c-.01.36.01.88.07,1.47h-.21c-.13-.81-.6-1.34-1.39-1.34-.53,0-.98.26-.98.9,0,1.43,2.79,1.35,2.79,3.29,0,1.52-1.27,1.73-1.78,1.73-.85,0-1.07-.22-1.73-.25,0-.47-.03-1.1-.08-1.72h.21c.16,1.03.62,1.64,1.59,1.64.58,0,.94-.3.94-.98,0-1.51-2.64-1.21-2.64-3.3,0-.94.65-1.62,1.72-1.62.65,0,.98.21,1.49.18Z"
                />
                <path
                  d="M20.25,22.58c-.18,0-.27,0-.27.08,0,.06.06.14.18.33l.94,1.53,1.14-1.57c.08-.12.14-.2.14-.26s-.06-.1-.19-.1h-.58v-.33h2.11v.33h-.39c-.35,0-.51.08-.74.39l-1.31,1.82,1.6,2.64c.21.35.26.36.68.36h.21v.33h-2.47v-.33h.34c.21,0,.29-.03.29-.1,0-.07-.06-.16-.16-.3l-1.1-1.79-1.29,1.78c-.07.09-.13.18-.13.26,0,.09.04.16.21.16h.56v.33h-2.18v-.33h.44c.29,0,.49-.09.72-.4l1.51-2.05-1.44-2.35c-.25-.39-.31-.4-.73-.4h-.16v-.33h2.46v.33h-.35Z"
                />
              </g>
            </svg>
            <span class="show-for-m">{{ "cart.bag-xlsx" | i18next }}</span>
          </div>
        </div>
        <modal id="generate-pdf">
          <div
            (click)="closeModal('generate-pdf')"
            class="close-button text-right"
          >
            <svg
              fill="#000"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="cancel_24px">
                <path
                  clip-rule="evenodd"
                  d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                  fill-opacity="1"
                  fill-rule="evenodd"
                  id="icon/navigation/cancel_24px"
                />
              </g>
            </svg>
          </div>
          <form [formGroup]="pdfForm">
            <div class="text-center">
              <h1>{{ "cart.pdf-modal-headline" | i18next }}</h1>
              <div class="grid">
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.vendor-name' | i18next }}"
                    formControlName="vendorName"
                    autocomplete="name"
                  />
                </div>
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.organization' | i18next }}"
                    formControlName="address1"
                    autocomplete="organization"
                  />
                </div>
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.street-address' | i18next }}"
                    formControlName="address2"
                    autocomplete="street-address"
                  />
                </div>
                <div class="xs-4">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.postal-code' | i18next }}"
                    formControlName="address3"
                    autocomplete="postal-code"
                  />
                </div>
                <div class="xs-8">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.country-name' | i18next }}"
                    formControlName="address4"
                    autocomplete="address-level2"
                  />
                </div>
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.telefon' | i18next }}"
                    formControlName="telefon"
                    autocomplete="tel"
                  />
                </div>
              </div>

              <div class="flex-container">
                <button
                  type="submit"
                  (click)="generatePDF(pdfForm)"
                  class="btn primary"
                >
                  {{ "cart.generate-pdf" | i18next }}
                </button>
              </div>
            </div>
          </form>
        </modal>
        <modal id="generate-csv">
          <div
            (click)="closeModal('generate-csv')"
            class="close-button text-right"
          >
            <svg
              fill="#000"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="cancel_24px">
                <path
                  clip-rule="evenodd"
                  d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                  fill-opacity="1"
                  fill-rule="evenodd"
                  id="icon/navigation/cancel_24px"
                />
              </g>
            </svg>
          </div>
          <form [formGroup]="pdfForm">
            <div class="text-center">
              <h1>{{ "cart.pdf-modal-headline" | i18next }}</h1>
              <div class="grid">
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.vendor-name' | i18next }}"
                    formControlName="vendorName"
                    autocomplete="name"
                  />
                </div>
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.organization' | i18next }}"
                    formControlName="address1"
                    autocomplete="organization"
                  />
                </div>
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.street-address' | i18next }}"
                    formControlName="address2"
                    autocomplete="street-address"
                  />
                </div>
                <div class="xs-4">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.postal-code' | i18next }}"
                    formControlName="address3"
                    autocomplete="postal-code"
                  />
                </div>
                <div class="xs-8">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.country-name' | i18next }}"
                    formControlName="address4"
                    autocomplete="address-level2"
                  />
                </div>
                <div class="xs-12">
                  <input
                    class="margin-b-1"
                    type="text"
                    placeholder="{{ 'cart.telefon' | i18next }}"
                    formControlName="telefon"
                    autocomplete="tel"
                  />
                </div>
              </div>

              <div class="flex-container">
                <button
                  type="submit"
                  (click)="generateCSV(pdfForm)"
                  class="btn primary"
                >
                  {{ "cart.generate-xlsx" | i18next }}
                </button>
              </div>
            </div>
          </form>
        </modal>
        <modal id="new-cart-missing-skus">
          <div
            (click)="closeModal('new-cart-missing-skus')"
            class="close-button text-right"
          >
            <svg
              fill="#000"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="cancel_24px">
                <path
                  clip-rule="evenodd"
                  d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                  fill-opacity="1"
                  fill-rule="evenodd"
                  id="icon/navigation/cancel_24px"
                />
              </g>
            </svg>
          </div>
          <div class="text-center">
            <h1>{{ "cart.b2b.new-cart-missing-skus.title" | i18next }}</h1>
            <div class="grid">
              <div class="xs-12">
                {{ "cart.b2b.new-cart-missing-skus.text" | i18next }}
              </div>
              <div class="xs-12">
                <p *ngFor="let sku of missingSkuText()">{{ sku }}</p>
              </div>
              <div class="xs-12 grid align-center">
                <!-- spacer -->
                <span class="m-3"></span>
                <button
                  class="xs-6 m-3 flex-container align-center-middle"
                  type="button"
                  (click)="b2bReset()"
                >
                  {{ "cart.b2b.cancel" | i18next }}
                </button>
                <button
                  class="xs-6 m-3 flex-container align-center-middle"
                  type="button"
                  (click)="b2bNewCartResume()"
                  *ngIf="missingSkus.length < cartItems.length"
                >
                  {{ "cart.b2b.continue" | i18next }}
                </button>
              </div>
            </div>
          </div>
        </modal>
        <modal id="add-cart-missing-skus">
          <div
            (click)="closeModal('add-cart-missing-skus')"
            class="close-button text-right"
          >
            <svg
              fill="#000"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="cancel_24px">
                <path
                  clip-rule="evenodd"
                  d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                  fill-opacity="1"
                  fill-rule="evenodd"
                  id="icon/navigation/cancel_24px"
                />
              </g>
            </svg>
          </div>
          <div class="text-center">
            <h1>{{ "cart.b2b.add-cart-missing-skus.title" | i18next }}</h1>
            <div class="grid">
              <div class="xs-12">
                {{ "cart.b2b.add-cart-missing-skus.text" | i18next }}
              </div>
              <div class="xs-12">
                <p *ngFor="let sku of missingSkuText()">{{ sku }}</p>
              </div>
              <div class="xs-12 grid align-center">
                <!-- spacer -->
                <span class="m-3"></span>
                <button
                  class="xs-6 m-3 flex-container align-center-middle"
                  type="button"
                  (click)="b2bReset()"
                >
                  {{ "cart.b2b.cancel" | i18next }}
                </button>
                <button
                  class="xs-6 m-3 flex-container align-center-middle"
                  type="button"
                  (click)="b2bAddCartResume()"
                  *ngIf="missingSkus.length < cartItems.length"
                >
                  {{ "cart.b2b.continue" | i18next }}
                </button>
              </div>
            </div>
          </div>
        </modal>
        <modal id="sf-login">
          <div (click)="closeModal('sf-login')" class="close-button text-right">
            <svg
              fill="#000"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="cancel_24px">
                <path
                  clip-rule="evenodd"
                  d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z"
                  fill-opacity="1"
                  fill-rule="evenodd"
                  id="icon/navigation/cancel_24px"
                />
              </g>
            </svg>
          </div>
          <form [formGroup]="sflogniform">
            <div class="text-center">
              <h1>{{ "cart.sflogin.text" | i18next }}</h1>
              <div class="grid">
                <div class="xs-12">
                  <label>
                    {{ "login.email" | i18next }}<br />
                    <input
                      class="margin-b-1"
                      type="email"
                      placeholder="{{ 'login.email' | i18next }}"
                      formControlName="username"
                      autocomplete="username"
                  /></label>
                </div>
                <div class="xs-12">
                  <label>
                    {{ "login.password" | i18next }}<br />
                    <input
                      class="margin-b-1"
                      type="password"
                      placeholder="{{ 'login.password' | i18next }}"
                      formControlName="password"
                      autocomplete="password"
                  /></label>
                </div>
              </div>

              <div class="flex-container">
                <button
                  type="button"
                  (click)="sfLogin()"
                  class="btn primary"
                  [disabled]="!sflogniform.valid"
                >
                  {{ "login.login" | i18next }}
                </button>
              </div>
            </div>
          </form>
        </modal>
        <div
          class="xs-2 m-2 flex-container align-center-middle pointer"
          (click)="b2bNewCart()"
        >
          <svg
            class="shrink margin-r-2"
            id="Ebene_2"
            height="40.16"
            width="40.89"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40.89 40.16"
          >
            <defs>
              <style>
                .cls-1 {
                  fill: #fff;
                }
              </style>
            </defs>
            <g id="Ebene_1-2" data-name="Ebene_1">
              <path
                d="M18.98,3.78c-5.6,0-10.13,4.39-10.13,11.47v13.44h3.01v-13.4c0-6.13,3.73-9.66,8.33-9.66s8.14,3.56,8.14,8.36h.61c0-5.88-4.42-10.2-9.95-10.2ZM18.98,1.91c6.62,0,11.98,4.77,11.98,13.34v24.13h3V15.05c0-9.52-6.31-15.05-13.62-15.05-5.17,0-9.69,2.91-11.95,7.15l.47.26c2.12-3.31,5.86-5.5,10.11-5.5Z"
              />
              <g>
                <path
                  d="M.27,35.18c.34-.49,1.14-1.55,1.84-1.55.33,0,.44.23.44.5,0,.23-.07.48-.12.67l-.44,1.36c.93-1.51,1.96-2.53,2.8-2.53.54,0,.79.31.79.82,0,.19-.03.39-.1.63l-.99,3.46c-.1.33-.16.57-.16.71,0,.11.04.15.12.15.25,0,.68-.61,1.01-.98l.15.16c-.57.86-1.18,1.57-1.78,1.57-.38,0-.49-.22-.49-.5s.1-.61.18-.86l.99-3.29c.04-.15.09-.35.09-.54,0-.26-.09-.48-.42-.48-.8,0-2.19,2.01-2.52,3.05l-.76,2.4s-.34.04-.76.19l-.14-.09,1.39-4.57c.1-.3.2-.63.2-.83,0-.11-.04-.19-.15-.19-.22,0-.54.42-.98.97l-.19-.19Z"
                />
                <path
                  d="M10.55,38.47c-.99,1.17-1.85,1.67-2.67,1.67s-1.28-.61-1.28-1.61c0-2.27,1.88-4.91,3.66-4.91.61,0,.99.35.99.93,0,1.7-2.3,2.42-3.54,2.65-.08.44-.12.73-.12,1.1,0,.68.22,1.14.8,1.14s1.28-.39,2-1.16l.15.18ZM10.38,34.48c0-.35-.14-.54-.45-.54-.78,0-1.74,1.24-2.15,2.99,1.46-.33,2.6-1.18,2.6-2.45Z"
                />
                <path
                  d="M16.84,33.61c.26,0,.44.1.44.45,0,.49-.25,1.02-.56,1.62-.16,1.47-.23,2.31-.23,2.79,0,.53.08.61.23.61.61,0,1.77-1.71,2.26-2.79.23-.49.35-.86.35-1.31,0-.25-.05-.49-.05-.69,0-.48.3-.68.63-.68.27,0,.44.19.44.56,0,.92-2.95,5.97-4.26,5.97-.26,0-.48-.04-.48-1.09,0-.46.04-1.13.14-2.07-1.01,1.59-2.23,3.16-2.86,3.16-.26,0-.44-.18-.44-.8,0-1.51.82-4.04.82-4.74,0-.14-.04-.22-.14-.22-.27,0-.68.59-.98.97l-.22-.19c.6-.82,1.29-1.55,1.87-1.55.3,0,.41.16.41.54,0,1.02-.82,3.73-.82,4.64,0,.19.05.29.18.29.44,0,1.62-1.77,2.26-2.86.16-2.41.72-2.61,1.02-2.61Z"
                />
              </g>
              <circle cx="33.47" cy="32.73" r="7.43" />
              <path
                class="cls-1"
                d="M37.06,32.22h-3.09v-3.09c0-.28-.22-.5-.5-.5s-.5.22-.5.5v3.09h-3.09c-.28,0-.5.22-.5.5s.22.5.5.5h3.09v3.09c0,.28.22.5.5.5s.5-.22.5-.5v-3.09h3.09c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
              />
            </g>
          </svg>
          <span
            class="show-for-m"
            [innerHTML]="'cart.b2b.new-cart' | i18next"
          ></span>
        </div>
        <div
          class="xs-2 m-2 flex-container align-center-middle pointer last-el"
          (click)="b2bAddCart()"
        >
          <svg
            class="shrink margin-r-2"
            id="Ebene_2"
            height="40.16"
            width="32.49"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32.49 40.16"
          >
            >
            <defs>
              <style>
                .cls-1 {
                  fill: #fff;
                }
              </style>
            </defs>
            <g id="Ebene_1-2" data-name="Ebene_1">
              <path
                d="M10.58,3.78C4.98,3.78.45,8.17.45,15.25v24.87h3.01V15.29c0-6.13,3.73-9.66,8.33-9.66s8.14,3.56,8.14,8.36h.61c0-5.88-4.42-10.2-9.95-10.2ZM10.58,1.91c6.62,0,11.98,4.77,11.98,13.34v24.13h3V15.05C25.57,5.54,19.26,0,11.95,0,6.78,0,2.26,2.91,0,7.15l.47.26C2.6,4.09,6.33,1.91,10.58,1.91Z"
              />
              <circle cx="25.07" cy="32.73" r="7.43" />
              <path
                class="cls-1"
                d="M28.66,32.22h-3.09v-3.09c0-.28-.22-.5-.5-.5s-.5.22-.5.5v3.09h-3.09c-.28,0-.5.22-.5.5s.22.5.5.5h3.09v3.09c0,.28.22.5.5.5s.5-.22.5-.5v-3.09h3.09c.28,0,.5-.22.5-.5s-.22-.5-.5-.5Z"
              />
            </g>
          </svg>
          <span
            class="show-for-m"
            [innerHTML]="'cart.b2b.add-cart' | i18next"
          ></span>
        </div>
        <!-- spacer -->
        <span class="xs-10 m-10"></span>
        <div
          *ngIf="priceActive"
          class="xs-12 m-12 flex-container align-right last-el cart-sum"
        >
          <h2 class="shrink margin-r-2 show-for-m flex-col-center">
            {{ "cart.sum" | i18next }}
          </h2>
          <div class="price">
            {{
              cartTotal
                | currency
                  : collectionsService.currencyCode
                  : currencySymbol
                  : "1.2-2"
                  : "de"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
